import { render, staticRenderFns } from "./CrmLayout.vue?vue&type=template&id=0e1860aa&scoped=true&"
import script from "./CrmLayout.vue?vue&type=script&lang=js&"
export * from "./CrmLayout.vue?vue&type=script&lang=js&"
import style0 from "./CrmLayout.vue?vue&type=style&index=0&id=0e1860aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1860aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VMain})
